import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {ErrorService} from '@app/services';
import {DiaporamaSearchParams} from '../diaporama-search-params';
import {DiaporamaService} from '../diaporama.service';
@Component({
  selector: 'hpf-diaporama-count',
  templateUrl: './diaporama-count.component.html'
})
export class DiaporamaCountComponent implements OnInit {
  /** The filters */
  @Input() searchParams: DiaporamaSearchParams = new DiaporamaSearchParams();
  /** Count result */
  count: number;
  /** Load flag */
  loaded = false;
  /** Constructor */
  constructor(private diaporamaService: DiaporamaService,
              private errorService: ErrorService) {}
  /** Init */
  ngOnInit() {
    this.diaporamaService.count(this.searchParams.toObject())
    .then((count) => {
      this.count = count;
      this.loaded = true;
    })
    .catch((error) => this.errorService.handle(error))
  }
}
